import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .FAccordion': {
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.overlay[1],
    border: `1px solid ${theme.palette.divider[4]}`,
    backgroundImage: 'none',
    borderRadius: theme.spacing(0.5),

    '& .Mui-expanded': {
      margin: 0,
    },
    '& .FAccordionSummary': {
      padding: theme.spacing(2.5, 3),
      gap: theme.spacing(3),
      '& .MuiAccordionSummary-content': {
        margin: 0,
      },
      '& .FIcon': {
        color: alpha(theme.palette.common.white, 0.56),
        width: theme.spacing(4),
        height: theme.spacing(4),
        padding: theme.spacing(0.2),
      },
    },
    '& .FAccordionDetails': {
      padding: theme.spacing(0, 3, 3),
      color: theme.palette.text.secondary,
      '& a': {
        color: theme.palette.common.white,
        fontWeight: 700,
      },
    },
  },
}));

export default StyledBox;
